import { render } from "./FlatCardTags.vue?vue&type=template&id=17068cec"
import script from "./FlatCardTags.vue?vue&type=script&lang=js"
export * from "./FlatCardTags.vue?vue&type=script&lang=js"

import "./FlatCardTags.vue?vue&type=style&index=0&id=17068cec&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__